import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ENV } from '../../../../src/app/interfaces/interfaces';
import { getEnvironment } from '../../../../src/app/environment/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { XtrasService } from '../../../../src/app/services/xtras.service';
import { ProjectConfigService } from '../../../../src/app/services/project-config.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgClass,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  
  env:ENV = getEnvironment();
  
  title = this.env.title;
  constructor(
    public router: Router,
    private gtmService: GoogleTagManagerService,
    private xServices: XtrasService,
    private projectConfig: ProjectConfigService,
  ) {
    let key = this.projectConfig.getConfig().keyMap;

    if(key) {
      this.xServices.loadInlineScriptBody(
        `
          (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.\${c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
            v: "weekly",
            key: "${key}"
          });
        `
      );
    }

    this.gtmService.addGtmToDom();
  }
}
